export const cardIcons = {
    visa: require('@/assets/images/creditcard-logos/visa.png'),
    mastercard: require('@/assets/images/creditcard-logos/mastercard.png'),
    discover: require('@/assets/images/creditcard-logos/discover.png'),
    'american express': require('@/assets/images/creditcard-logos/amex.png'),
    card: undefined,
}
